/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Dash_Title4Inputs */

const en_svc_ai_integration_dash_title4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structured output handling`)
};

const ar_svc_ai_integration_dash_title4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معالجة المخرجات المنظمة`)
};

const bn_svc_ai_integration_dash_title4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্ট্রাকচার্ড আউটপুট হ্যান্ডলিং`)
};

const de_svc_ai_integration_dash_title4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strukturierte Ausgabeverarbeitung`)
};

const es_svc_ai_integration_dash_title4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manejo de salida estructurada`)
};

const fr_svc_ai_integration_dash_title4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des sorties structurées`)
};

const pt_svc_ai_integration_dash_title4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manipulação de saída estruturada`)
};

const zh_svc_ai_integration_dash_title4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结构化输出处理`)
};

const tr_svc_ai_integration_dash_title4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapılandırılmış çıktı yönetimi`)
};

const ru_svc_ai_integration_dash_title4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка структурированного вывода`)
};

const pl_svc_ai_integration_dash_title4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strukturalna obsługa wyników`)
};

/**
* | output |
* | --- |
* | "Structured output handling" |
*
* @param {Svc_Ai_Integration_Dash_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_dash_title4 = /** @type {((inputs?: Svc_Ai_Integration_Dash_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Dash_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_dash_title4(inputs)
	if (locale === "bn") return bn_svc_ai_integration_dash_title4(inputs)
	if (locale === "de") return de_svc_ai_integration_dash_title4(inputs)
	if (locale === "es") return es_svc_ai_integration_dash_title4(inputs)
	if (locale === "fr") return fr_svc_ai_integration_dash_title4(inputs)
	if (locale === "pt") return pt_svc_ai_integration_dash_title4(inputs)
	if (locale === "zh") return zh_svc_ai_integration_dash_title4(inputs)
	if (locale === "tr") return tr_svc_ai_integration_dash_title4(inputs)
	if (locale === "ru") return ru_svc_ai_integration_dash_title4(inputs)
	if (locale === "pl") return pl_svc_ai_integration_dash_title4(inputs)
	return en_svc_ai_integration_dash_title4(inputs)
});
export { svc_ai_integration_dash_title4 as "svc_ai-integration_DASH_title" }